import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({
	createDate: {
		k: "create.date",
		v: "Member Since: ${date}",
		argNames: ["date"]
	}
});



// WEBPACK FOOTER //
// ./src/panels/userDetails/UserDetails.label.ts